<template>
  <v-app id="app_measurements">
    <v-overlay
      v-model="centerLoading"
      :scrim="false"
      class="custom_centered_overlay"
    >
      <v-progress-circular
        color="#2A8200"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row>
        <v-col class="mt-0" cols="7">
          <p class="custom_page_main_title">TIME MANAGEMENT</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Used to configure the business hours.
          </p>
        </v-col>
        <v-col class="px-4 mt-7" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="pa-5 mt-8">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedDay"
              :items="days"
              label="Day*"
              variant="outlined"
              density="comfortable"
              class="custom_input_field_color"
              item-title="name"
              item-value="value"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="dayInMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayInTime"
                  label="Day In"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayInTime"
                format="24hr"
                @click:minute="dayInMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="dayInBufferMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayInBufferTime"
                  label="Day In Buffer"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayInBufferTime"
                format="24hr"
                @click:minute="dayInBufferMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="morningHDMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="morningHDTime"
                  label="Morning HD Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="morningHDTime"
                format="24hr"
                @click:minute="morningHDMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="afternoonHDMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="afternoonHDTime"
                  label="Afternoon HD Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="afternoonHDTime"
                format="24hr"
                @click:minute="afternoonHDMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4">
            <v-menu
              v-model="fullDayLeaveMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="fullDayLeaveTime"
                  label="Full Day Leave"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="fullDayLeaveTime"
                format="24hr"
                @click:minute="fullDayLeaveMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-menu
              v-model="dayOutMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dayOutTime"
                  label="Day Out"
                  variant="outlined"
                  readonly
                  v-bind="props"
                  class="custom_input_field_color"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="dayOutTime"
                format="24hr"
                @click:minute="dayOutMenu = false"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>

          <v-row justify="end" class="pa-4">
            <v-btn
              size="x-large"
              class="custom_btn_primary pl-5 pr-5"
              @click="Create"
              >Create</v-btn
            >
            <v-btn
              size="x-large"
              class="custom_btn_secondary ml-3"
              @click="cancel()"
              >Cancel</v-btn
            >
          </v-row>

          <v-divider></v-divider>
        </v-row>

        <v-row>
          <v-col class="mt-0" cols="7">
            <p class="custom_page_main_title">LIST OF TIME DATA</p>
            <p class="custom_page_main_sub_title" style="opacity: 0.6">
              List of the all configure business hours.
            </p>
          </v-col>

          <v-data-table
            v-model:page="page"
            :loading="loading"
            :headers="headers"
            :items="filteredItems"
            :items-per-page="itemsPerPage"
            class="custom_table_normal"
            @update:page="page = $event"
            @page-count="totalPages = $event"
          >
            <!-- Custom Styling for DAY column -->
            <template v-slot:[`item.DAY`]="{ item }">
              <span style="color: blue; font-weight: bold">{{ item.DAY }}</span>
            </template>

            <!-- Custom Styling for DAY IN column -->
            <template v-slot:[`item.DAY_IN`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                item.DAY_IN
              }}</span>
            </template>
            <template v-slot:[`item.DAY_IN_BUFFER`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                item.DAY_IN_BUFFER
              }}</span>
            </template>

            <!-- DELETE Button -->
            <template v-slot:[`item.actions`]="{}">
              <v-btn
                style="
                  width: 70% !important;
                  background-color: #fdecea !important;
                  border: 1px solid #f44336 !important;
                  color: #f44336 !important;
                "
                variant="outlined"
                @click="delete_TIMEMANAGE_dialog = true"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-row>

        <v-dialog
          v-model="delete_TIMEMANAGE_dialog"
          max-height="500"
          max-width="500"
          persistent
          id="app_product_list"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold"
                    >DELETE TIME MANAGEMENT DATA</v-card-title
                  >
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="delete_TIMEMANAGE_dialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <v-card color="white" flat class="mt-3">
                <v-card-item>
                  <v-card-title
                    style="color: #bb0000"
                    class="text-body-1 font-weight-medium"
                  >
                    <v-icon color="warning" size="small">mdi-alert</v-icon>
                    &nbsp;&nbsp;Do you want to delete this time record ?
                  </v-card-title>

                  <p style="opacity: 0.7" class="text-body-2 mt-4 text-justify">
                    This will be deleted immediately. Once deleted, it can no
                    longer be used for any purpose.
                    <span style="color: blue">
                      Further, these modules are also related to the following
                      others, so please read and confirm before deleting this.
                    </span>
                  </p>

                  <v-timeline align="start" density="compact">
                    <v-timeline-item>
                      <template v-slot:opposite> </template>
                      <div>
                        <div class="text-h6">related area 01</div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </v-timeline-item>

                    <v-timeline-item>
                      <template v-slot:opposite> </template>
                      <div>
                        <div class="text-h6">related area 02</div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </v-timeline-item>
                  </v-timeline>

                  <v-divider class="mt-4"></v-divider>

                  <div class="float-end mt-4">
                    <v-btn
                      style="
                        width: 35% !important;
                        background-color: #fdecea !important;
                        border: 1px solid #f44336 !important;
                        color: #f44336 !important;
                      "
                      variant="outlined"
                      @click="delete_TIMEMANAGE_dialog = true"
                    >
                      DELETE
                    </v-btn>
                    <v-btn
                      class="ml-3 custom_btn_secondary"
                      @click="delete_TIMEMANAGE_dialog = false"
                      >CANCEL</v-btn
                    >
                  </div>
                </v-card-item>
              </v-card>
            </div>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      // Days dropdown data
      days: [
        { name: "Monday", value: "Monday" },
        { name: "Tuesday", value: "Tuesday" },
        { name: "Wednesday", value: "Wednesday" },
        { name: "Thursday", value: "Thursday" },
        { name: "Friday", value: "Friday" },
        { name: "Saturday", value: "Saturday" },
        { name: "Sunday", value: "Sunday" },
      ],
      selectedDay: null,
      
      // Time pickers data
      dayInTime: null,
      dayInMenu: false,
      
      dayInBufferTime: null,
      dayInBufferMenu: false,
      
      morningHDTime: null,
      morningHDMenu: false,
      
      afternoonHDTime: null,
      afternoonHDMenu: false,
      
      fullDayLeaveTime: null,
      fullDayLeaveMenu: false,
      
      dayOutTime: null,
      dayOutMenu: false,

      delete_TIMEMANAGE_dialog: false,
      userPermissions: ["delete"],
      centerLoading: false,
      
      page: 1,
      loading: false,
      itemsPerPage: 10,
      headers: [
        { text: "DAY", value: "DAY", sortable: true, title: "DAY" },
        { text: "DAY IN", value: "DAY_IN", sortable: true, title: "DAY IN" },
        {
          text: "DAY IN BUFFER",
          value: "DAY_IN_BUFFER",
          sortable: true,
          title: "DAY IN BUFFER",
        },
        {
          text: "MORNING HD LEAVE",
          value: "MORNING_HD_LEAVE",
          sortable: true,
          title: "MORNING HD LEAVE",
        },
        {
          text: "AFTERNOON HD LEAVE",
          value: "AFTERNOON_HD_LEAVE",
          sortable: true,
          title: "AFTERNOON HD LEAVE",
        },
        { text: "DAY OUT", value: "DAY_OUT", sortable: true, title: "DAY OUT" },
        {
          text: "CREATION DATE",
          value: "CREATION_DATE",
          sortable: true,
          title: "CREATION DATE",
        },
        { text: "ACTION", value: "actions", sortable: false, title: "ACTION" },
      ],
      filteredItems: [
        {
          DAY: "Monday",
          DAY_IN: "8:30 AM",
          DAY_IN_BUFFER: "8:45 AM",
          MORNING_HD_LEAVE: "6:30 AM",
          AFTERNOON_HD_LEAVE: "12:30 PM",
          DAY_OUT: "5:30 AM",
          CREATION_DATE: "2025-01-01",
        },
        {
          DAY: "Tuesday",
          DAY_IN: "8:30 AM",
          DAY_IN_BUFFER: "8:45 AM",
          MORNING_HD_LEAVE: "6:30 AM",
          AFTERNOON_HD_LEAVE: "12:30 PM",
          DAY_OUT: "5:30 AM",
          CREATION_DATE: "2025-01-01",
        },
      ],
    };
  },
  methods: {
    hasPermission(permission) {
      return this.userPermissions.includes(permission);
    },
    Create() {
      // Handle create logic here
    },
    cancel() {
      // Handle cancel logic here
    },
    backPageRoute() {
      // Handle back navigation
    },
  },
};
</script>

<style scoped></style>